import React from 'react';
import '../less/war-time.less';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import questions_top_img from '../img/questions_top_img.png';

export default function template() {
  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="war-time-new">
      <div className="war-time-new__top">
        <div className="container">
          <div className="war-time-new__row">
            <div className="war-time-new__left">
              <h1 className="war-time-new__title">{this.l10n("SERVICES_WAR_TIME_NEW_TITLE")}</h1>
              <div className="war-time-new__text">{this.l10n("SERVICES_WAR_TIME_NEW_TEXT")}</div>
            </div>
            <img src={questions_top_img} className="war-time-new__image" alt="war time image" />
          </div>
        </div>
      </div>
      <QuestionsAdminNew
        widget={questionsWidget}
        showAll
        loader={this.state.loader}
        questionTag={"h2"}
      />
    </div>
  );
}
